import { serviceOnPageContent } from "./onPageContent";

const forceAndHardnessSections = [
  {
    title: "FORCE",
    entries: [
      {
        parameter: "Verification of Uniaxial Testing Machine ( UTM/CTM/TTM )",
        range: "0 N to 1000 KN",
      },
      {
        parameter: "Push Pull Meter / Load Cell",
        range: "0 Newton to 2000 Newton",
      },
      {
        parameter: "Verification of Displacement",
        range: "Upto 600 mm",
      },
      {
        parameter: "Verification of speed of Material Testing Machines",
        range: "Upto 600 mm/min",
      },
      {
        parameter: "Test Force Verification of Rockwell Hardness Tester",
        range: "3,10,15,30,45,60,100 & 150 Kgf",
      },
      {
        parameter: "Test Force Verification of Brinell Hardness Tester",
        range: "31.25,62.5,187.5,250, 500,750,1000,1500 & 3000 kgf",
      },
      {
        parameter: "Test Force Verification of Vickers Hardness Tester",
        range: "1,5,10,20,30 & 50 kgf",
      },
    ],
  },
  {
    title: "HARDNESS",
    entries: [
      {
        parameter: "Verification of Rockwell Hardness Tester by Indirect Method",
        range: "20 to 95 HRA\n20 to 100 HRBW\n20 to 70 HRC",
      },
      {
        parameter: "Verification of Brinell Hardness Tester by Indirect Method",
        range:
          "100 to 600 HBW 2.5 / 187.5\n100 to 600 HBW 5 / 750\n100 to 600 HBW 10/3000",
      },
      {
        parameter: "Verification of Vickers Hardness Tester by Indirect Method",
        range: "HV 1\nHV 5\nHV 10\nHV 20\nHV 30\nHV 50",
      },
    ],
  },
  {
    title: "IMPACT",
    entries: [
      {
        parameter: "Verification of Impact Testing Machine",
        range: "Upto 300 J",
      },
    ],
  },
  {
    title: "EXTENSOMETER",
    entries: [
      {
        parameter: "Verification of class 1 Extensometer",
        range: "1) Mechanical\n2) Electronic",
      },
    ],
  },
];

const baseServiceCategories = [
  {
    slug: "electrical-calibration",
    name: "Electrical Calibration",
    shortName: "Electrical Calibration",
    legacyName: "Electro-Technical",
    heroImage: "/img/section-capabilities-premium.jpg",
    metaDescription:
      "Electrical calibration services for multifunction calibrators, digital multimeters, clamp meters, power analyzers, oscilloscopes and related instruments in Pune.",
    intro:
      "Recon Calibration & Test Labs LLP provides calibration support for electro-technical instruments used in testing, maintenance, quality control and process validation.",
    items: [
      "Universal Calibrators / Multifunction Calibrator",
      "Up to 6 1/2 Digit Digital Multimeters",
      "Clamp on meters (3500A AC & 1000A DC)",
      "High Voltage Breakdown testers (100kV AC/DC)",
      "Power / PF Meters",
      "Power Analyzers",
      "Power Quality meters",
      "Signal Generators",
      "Frequency Counters",
      "Resistance, Capacitance, Inductance - Decade box",
      "LCR Meters & Bridges",
      "Insulation testers",
      "Temp. Controller / Indicator / Scanner",
      "Digital / Analog Ammeter",
      "Data Acquisition System",
      "Data loggers",
      "Oscilloscope",
      "Digital / Analog Voltmeter",
      "Hipot Testers",
      "Micro Ohm Meter",
      "Battery Testers",
      "Current Source",
      "Voltage Source",
      "HV Probes AC/DC (100kV AC/DC)",
      "HV Divider AC/DC (100kV AC/DC)",
      "Std. CT (Up to 6000 AC @ class 0.05)",
      "Std PT (Up to 33 kV)",
      "CT Burden Box",
      "PT Burden Box",
      "Timer / Time Interval Meter",
      "V, I & R Calibrator",
      "Earth testers",
      "VAW Meter",
      "PH Meter (By Simulation Method)",
      "Loop Calibrator",
      "Energy Meter",
    ],
  },
  {
    slug: "dimensional-calibration",
    name: "Dimensional Calibration",
    shortName: "Dimensional Calibration",
    legacyName: "Dimensions",
    heroImage: "/img/section-precision-premium.jpg",
    metaDescription:
      "Dimensional calibration services for callipers, micrometers, dial gauges, gauge blocks, profile projectors and other dimensional instruments in Pune.",
    intro:
      "Our dimensional calibration service covers precision measuring instruments used for inspection, production and laboratory verification.",
    items: [
      "Calliper (Vernier/Dial/Digital)",
      "Depth Gauge (Vernier/Dial/Digital)",
      "Height Gauge (Vernier/Dial/Digital)",
      "External Micrometer",
      "Depth Micrometer",
      "Internal Micrometer",
      "Dial Gauge (Plunger Type)",
      "Dial Gauge (Lever Type)",
      "Bore Gauge",
      "Dial Snap Gauge",
      "Inside Dial Calliper",
      "Dial Thickness Gauge",
      "Bevel Protector",
      "Plain Plug Gauge / OD Master / Height / Width / Flush Pin Gauge",
      "Thread Plug Gauge Taper Thread Plug",
      "Snap Gauge",
      "Feeler Gauge Set / Thickness Foils",
      "Measuring Pin / Thread Measuring Wire",
      "Engineering Square",
      "Angle Plate / Box Angle",
      "Comparator with Stand / Electronic Probe with DRO / Comparator",
      "Flatness of Base Snap Gauge",
      "Coating Thickness Gauge",
      "Thread Ring Gauge",
      "Plain Ring Gauge",
      "Slip Gauges Sets",
      "Radius Gauge",
      "Thread Pitch Gauge",
      "Measuring Tape",
      "Measuring Scale",
      "Scale / Tape Calibrator",
      "ULM",
      "Surface Plate",
      "Linear Height Measuring Instrument",
      "Profile Projector / Video Measuring System",
      "Micrometer Setting Stick / Length Bar",
      "V Block",
    ],
  },
  {
    slug: "pressure-calibration",
    name: "Pressure Calibration",
    shortName: "Pressure Calibration",
    legacyName: "Pressure",
    heroImage: "/img/section-assurance-premium.jpg",
    metaDescription:
      "Pressure calibration services for pressure gauges, transmitters, switches, magnehelic gauges and vacuum instruments in Pune, India.",
    intro:
      "We calibrate pneumatic, hydraulic and vacuum instruments to support dependable process measurements across industrial applications.",
    items: [
      "Vacuum Gauge / Transmitter (-1 to 0 bar)",
      "Pressure Gauge / Transmitter (Pneumatic) 0 to 40 bar",
      "Pressure Switch",
      "Magnehelic Gauge",
      "Pressure Gauge / Transmitter (Hydraulic) 0 to 1000 bar",
    ],
  },
  {
    slug: "mass-volume-calibration",
    name: "Mass & Volume Calibration",
    shortName: "Mass & Volume Calibration",
    legacyName: "Mass & Volume",
    heroImage: "/img/section-industries-premium.jpg",
    metaDescription:
      "Mass and volume calibration services for standard weights, balances, glassware, flasks, pipettes and measuring cylinders in Pune.",
    intro:
      "Our mass and volume calibration scope supports laboratory glassware, weighing instruments and reference weights used in regulated environments.",
    items: [
      "Std. Weights",
      "Weighing Balance (Up to 500 kg)",
      "Glassware",
      "Volumetric Flask",
      "Burette",
      "Conical Flask",
      "Glass Pipette",
      "Micropipette",
      "Measuring Cylinder",
    ],
  },
  {
    slug: "thermal-calibration",
    name: "Thermal Calibration",
    shortName: "Thermal Calibration",
    legacyName: "Thermal",
    heroImage: "/img/section-nationwide-premium.jpg",
    metaDescription:
      "Thermal calibration services for humidity generators, chambers, ovens, freezers, thermometers, RTDs, PRTs and temperature transmitters in Pune.",
    intro:
      "Recon Calibration & Test Labs LLP handles temperature and humidity calibration requirements for chambers, sensors, indicators and mapping applications.",
    items: [
      "Humidity Calibrator (Single Point)",
      "Humidity Generator (Single Point)",
      "Temp. & Humidity Chamber (Single Point)",
      "Temp. & Humidity Chamber (Multi Points Mapping)",
      "Thermo Hygrometer",
      "RH Sensor with Indicator",
      "Dry Block Furnace (Single Point / Multi Points)",
      "Freezer (Single Point / Multi Points Mapping)",
      "Oven (Single Point / Multi Points Mapping)",
      "Glass, Dial Thermometer",
      "Incubator (Single Point / Multi Points Mapping)",
      "Furnace (Single Point / Multi Points Mapping)",
      "Environmental (Single Point / Multi Points Mapping)",
      "Chamber, BOD (Single Point / Multi Points Mapping)",
      "Incubator (Single Point / Multi Points Mapping)",
      "Liquid Bath (Single Point / Multi Points Mapping)",
      "Dry Block (Single Point)",
      "RTD Sensor",
      "PRT Sensor",
      "Thermocouple",
      "Temp. Transmitter with or without Indicator",
    ],
  },
  {
    slug: "force-hardness-calibration",
    name: "Force & Hardness Calibration",
    shortName: "Force & Hardness Calibration",
    legacyName: "Force & Hardness",
    heroImage: "/img/section-precision-premium.jpg",
    metaDescription:
      "Force and hardness calibration services for UTM, CTM, load cells, hardness testers, impact testing machines and extensometers in Pune.",
    intro:
      "We provide force and hardness calibration support for testing machines, verification systems and allied quality instruments.",
    sections: forceAndHardnessSections,
  },
];

export const serviceCategories = baseServiceCategories.map((service) => ({
  ...service,
  ...(serviceOnPageContent[service.slug] || {}),
}));

export const getServiceBySlug = (slug) =>
  serviceCategories.find((service) => service.slug === slug);

export const getRelatedServices = (slug) =>
  serviceCategories.filter((service) => service.slug !== slug);
